angular.module("vgresiduos").controller("EditActionPlanCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";
		this.$onInit = function () {
			Vgr.util.redirectSingleton(
				$rootScope,
				`organizacao/fornecedores/${$stateParams.supplierCode}/plano-de-acao/${$stateParams.actionPlanId}`,
				getQueries()
			);
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.isSupplierView) {
				queries.push({ key: "isSupplierView", value: $stateParams.isSupplierView });
			}
			if ($stateParams.pendente) {
				queries.push({ key: "pendingApproval", value: true });
			}
			return queries;
		}
	}
]);
